import "./Modal.css";
import { useContext, useEffect } from "react";
import { BefGlobalContext, BefLanguageServiceContext, BefMessage, BefMessageButtonType, BefMessageControllerServiceContext, BefMessageResult, BefMessageType } from "@beflam/bef-core";
import { Collapse, Dialog } from "@alifd/next";
import React from "react";

export function Modal(props: any) {
    const Panel = Collapse.Panel;
    let [message, setMessage] = React.useState<BefMessage>(props.message)
    let [messageButtons, setMessageButtons] = React.useState<any>([])
    let [showModal, setShowModal] = React.useState(true)
    let [showCloseIcon, setShowCloseIcon] = React.useState(true)
    // let [timeOut, setTimeOut] = React.useState(0)

    let befLanguageService = useContext(BefLanguageServiceContext);
    let globalService = useContext(BefGlobalContext);
    let messageController = useContext(BefMessageControllerServiceContext);
    useEffect(() => {
        let singlePage = globalService.isSinglePage;
        //单页面模式，不显示http详细错误
        if (singlePage && message.message && message.message.indexOf("Http failure") >= 0) message.message = "HTTP请求错误";
        setShowCloseIcon(message.showCloseIcon);
        if (props.message.title === "") {
            props.message.title = "系统提示";
            setMessage(props.message)
        }
        let _messageButtons = [];

        //这里需要对BefMessage的Type进行处理
        if (message.buttonType != null) {
            //这里前面添加一个加号，是为了把enum类型转为int类型才能比较
            switch (+message.buttonType) {
                case BefMessageButtonType.YesAndNo:
                    _messageButtons.push({ text: befLanguageService.getLanguage("framework", "Cancel"), result: BefMessageResult.No });
                    _messageButtons.push({ text: befLanguageService.getLanguage("framework", "OK"), result: BefMessageResult.Yes });
                    break;
                case BefMessageButtonType.Ok:
                    _messageButtons.push({ text: befLanguageService.getLanguage("framework", "OK"), result: BefMessageResult.Ok });
                    break;
            }

        }
        if (_messageButtons.length <= 0) {
            if (message.type !== BefMessageType.normal || (message.trace && message.trace.length > 0)) {
                _messageButtons.push({ text: befLanguageService.getLanguage("framework", "OK"), result: BefMessageResult.Ok });
            }
            else if (globalService.beflamFrameworkClientConfig.ToastMessage) {
                setShowModal(false);
            }
            else {
                _messageButtons.push({ text: befLanguageService.getLanguage("framework", "OK"), result: BefMessageResult.Ok });
            }
        }
        setMessageButtons(_messageButtons);
        if (!showModal) {

        }
        else {
            // $(modalElementRef)?.modal('show');
            popupShow(message, _messageButtons);
        }
    }, []);
    // const onClose = () => {
    //     $(modalElementRef).modal('hide');
    // }

    const popupShow = (message: BefMessage, _messageButtons?: any) => {
        let func;
        let className = '';
        switch (message.type) {
            case BefMessageType.normal: {
                func = Dialog.success;
                className = 'bef-message-normal';
                break;
            }
            case BefMessageType.crash: {
                func = Dialog.error;
                className = 'bef-message-crash';
                break;
            }
            case BefMessageType.communication: {
                func = Dialog.notice;
                className = 'bef-message-communication';
                break;
            }
            case BefMessageType.serious: {
                func = Dialog.warning;
                className = 'bef-message-serious';
                break;
            }
        }
        const dialog = func({
            className: `bef-message ${className}`,
            v2: true,
            title: message.title,
            content: (
                <>
                    <p style={{ wordWrap: "break-word", wordBreak: "break-all", overflow: "hidden", color: '#98a5c3', fontSize: '0.8rem' }}>{message.message}</p>
                    {(message.innerMessage || message.trace) && <Collapse>
                        {
                            message.innerMessage &&
                            (<Panel title="展开查看详细信息">
                                {message.innerMessage}
                            </Panel>)
                        }
                        {
                            message.trace &&
                            (<Panel>
                                {message.trace}
                            </Panel>)
                        }
                    </Collapse>
                    }
                </>
            ),
            footerAlign: 'center',
            footer: (
                _messageButtons.map((button: any) => {
                    return <a onClick={() => { onResult(button.result); dialog.hide(); }} className={`btn ${button.result === BefMessageResult.No ? 'btn-outline btn-default' : 'btn-ok'}`}>{button.text}</a>
                })
            )
        });
    };
    // let modalElementRef: any;
    const onResult = (result: BefMessageResult) => {
        // $(modalElementRef).modal('hide');
        // this.toasttemplate.hide('All')
        messageController.closeMessage(message);
        message.onResult(result);
    }

    return (
        <>
        </>
    )
}